// extracted by mini-css-extract-plugin
export default {"folioRecordTypeContainer":"folioRecordTypeContainer---tW4kb","error":"error---pU4zn"};